{
  "eyebrow": "You're in",
  "title": "Welcome to Done-it, {{company}}.",
  "titleGeneric": "Welcome to Done-it.",
  "sub": "Your 30-day trial of {{plan}} is active. Three things to do next.",
  "subGeneric": "Your account is active. Three things to do next.",
  "next1": {
    "title": "Download the mobile app",
    "desc": "Send the install link to your team via SMS or email.",
    "cta": "Send invite link"
  },
  "next2": {
    "title": "Invite your team",
    "desc": "Bulk-import employees from CSV, or add them one by one.",
    "cta": "Open admin"
  },
  "next3": {
    "title": "Watch a 4-minute tour",
    "desc": "See how to set up your first project and locations.",
    "cta": "Watch video"
  },
  "cta": "Go to dashboard",
  "receipt": "A receipt and onboarding email are on their way to {{email}}.",
  "receiptGeneric": "A receipt and onboarding email are on their way.",
  "fallbacks": {
    "company": "your company",
    "plan": "your plan",
    "inbox": "your inbox"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Your {{plan}} account is active — free forever. Three things to do next."
}
